import React, { useState, useEffect } from 'react';
import { Input, Loading, OverlayTrigger, PopOver, Select } from '@tencent/spaui';
import './index.less';
import { message } from '@tencent/ptp-fe-common';
import classname from 'classnames';

const DEFAULT_DISPLAY_NUMBER = [{
  label: '系统分配',
  value: '',
}];

const TcccControlUi = ({ updateDisplayNumber, displayNumberList, callNumberFn, logoutTccc, seatNumber, loading, tcccConnectStatus, stopPhoneNumber, showTcccControlUi }) => {
  const [phoneNumber, setPhoneNumber] = useState('');
  const [systemNumber, setSystemNumber] = useState('');
  const [data, setData] = useState(DEFAULT_DISPLAY_NUMBER);
  const callPhoneNumber = () => {
    if(phoneNumber === '') return;
    callNumberFn(phoneNumber);
  };

  const logoutTcccFn = () => {
    if(tcccConnectStatus === 'connect') {
      message.error('如果需要关闭TCCC,请先结束当前通话');
      return;
    }
    updateDisplayNumber?.('');
    setSystemNumber('');
    setPhoneNumber('');
    logoutTccc();
  };

  useEffect(() => {
    if(displayNumberList?.length > 0) {
      setData([...DEFAULT_DISPLAY_NUMBER, ...displayNumberList.map((number) => {
        return {
          label: `${String(number).slice(4, 8)}-${String(number).slice(8)}`,
          value: number,
        };
      })]);
    }
  }, [displayNumberList]);

  const setPopoverPosition = (top) => {
    const style = document.createElement('style');
    style.type = 'text/css';
    const cssContent = document.createTextNode(`.tccc-popover-container { top: ${top}px !important }`);
    style.appendChild(cssContent);
    document.head.appendChild(style);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      const controlDom = document.getElementsByClassName('tccc-control-btn')?.[0]?.getBoundingClientRect();
      if(controlDom) {
        const popoverHeight = 235;
        const top = controlDom.top - popoverHeight;
        setPopoverPosition(top);
      }
      clearTimeout(timer);
    }, 1000);
  }, []);
  return (
   <div className="tccc-control-btn" style={{ right: showTcccControlUi ? '80px' : '-1000px' }}>
     {/* 这一部分这么写是为了绕开tccc的 t3c-agent-poper不能重复销毁导致的bug。 所以初始化加载一次就不再销毁，只做隐藏 */}
      <div className={ classname('tccc-default-ui', {
        show: showTcccControlUi && !loading,
      })} ><t3c-agent-poper /></div>
        {
          showTcccControlUi ?   <>
             {
              loading ?  <Loading /> : <>
                <div className="tccc-people-number">
                  <div className="tccc-title">排队人数</div>
                  <div className="tccc-value">{seatNumber || 0}</div>
                </div>
                <OverlayTrigger
                  placement="top"
                  trigger="click"
                  overlay={
                    <PopOver className="tccc-popover-container">
                       <Select
                          open
                          search
                          placeholder='总机号码'
                          value={systemNumber}
                          onChange={ (e, number) => {
                            setSystemNumber(number);
                            updateDisplayNumber?.(number);
                            if(number) {
                              message.success('外显号码已更新' + `为${String(number).slice(4, 8)}-${String(number).slice(8)}`);
                            }else{
                              message.success('外显号码已更新为系统分配');
                            }
                          }}
                          data={data}
                          style={({ width: '236px' })}
                        />

                    </PopOver>
                  }
                >
                  <div className="tccc-selected-call-number">
                     <svg className="tccc-selected-call-number-icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6029" width="200" height="200"><path d="M809.370223 409.879158c-93.231381-30.68179-55.840796-89.130993-111.830995-111.832018-95.059006-38.546921-186.391131-37.281091-186.391131-37.281091s-91.031273-0.968048-186.387038 37.281091c-56.103786 22.512736-18.60473 81.149205-111.836111 111.832018-98.559736 32.432667-150.004409-15.096836-148.959613-73.812099 0.740874-39.36352 24.972764-83.760682 74.405617-112.578008 126.557394-73.808006 372.776122-74.55502 372.776122-74.55502s246.223844 0.748037 372.780215 74.55502c49.055253 28.630061 73.325006 72.579015 74.365708 111.721501C959.860702 394.334113 908.4191 442.459181 809.370223 409.879158L809.370223 409.879158zM383.915321 383.40418l63.444984 0 0 63.956637 127.913275 0 0-63.956637 63.956637 0 0 63.956637 256.167311 223.464491 0 149.109016c0 41.154305-44.871977 74.557066-86.027305 74.557066L212.923926 894.491391c-41.153282 0-85.005023-33.403784-85.005023-74.557066L127.918903 670.825308l255.997442-223.464491L383.916345 383.40418 383.915321 383.40418zM511.898181 799.85808c70.621431-0.001023 127.877459-57.256028 127.877459-127.872343 0-70.623477-57.256028-127.878482-127.877459-127.878482-70.616314 0-127.873366 57.255005-127.873366 127.878482C384.024815 742.602052 441.281867 799.85808 511.898181 799.85808L511.898181 799.85808z" p-id="6030"></path></svg>
                  </div>
                </OverlayTrigger>
                <div className="tccc-call-number">
                  <Input className="tccc-call-input" placeholder="请输入号码拨打" value={phoneNumber} onChange={(...rest) => {
                    setPhoneNumber(rest[1]);
                  }} />
                  {
                    tcccConnectStatus === 'over' ?  <svg onClick={callPhoneNumber} t="1729744056416" className="tcc-call-icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1474" width="200" height="200"><path d="M512 512m-512 0a512 512 0 1 0 1024 0 512 512 0 1 0-1024 0Z" fill="#A7F9DE" p-id="1475"></path><path d="M409.134545 282.298182l-101.236363-101.236364a23.272727 23.272727 0 0 0-33.047273 1.629091l-74.938182 91.461818a111.709091 111.709091 0 0 0-6.050909 134.050909 1661.905455 1661.905455 0 0 0 421.934546 421.701819 111.709091 111.709091 0 0 0 134.050909-6.05091l91.461818-74.705454a23.272727 23.272727 0 0 0 1.629091-33.047273l-101.003637-101.003636a44.683636 44.683636 0 0 0-53.294545-7.447273l-83.316364 46.545455a44.683636 44.683636 0 0 1-53.294545-7.447273l-174.312727-174.312727a44.683636 44.683636 0 0 1-7.447273-53.527273l46.545454-83.316364a44.683636 44.683636 0 0 0-7.68-53.294545z" fill="#1CD38D" p-id="1476"></path></svg> : null
                  }
                  {
                    tcccConnectStatus === 'connect' ?  <svg onClick={stopPhoneNumber} t="1730953417057" className="tcc-call-icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5996" width="200" height="200"><path d="M512 1023.999069a508.779681 508.779681 0 0 1-199.291759-40.238472 510.300163 510.300163 0 0 1-162.745886-109.73071A510.354466 510.354466 0 0 1 40.231646 711.284001 508.826226 508.826226 0 0 1 0.000931 512a508.841741 508.841741 0 0 1 40.238472-199.291759 510.338951 510.338951 0 0 1 109.73071-162.745886A510.292406 510.292406 0 0 1 312.708241 40.239403 508.787439 508.787439 0 0 1 512 0.000931a508.795196 508.795196 0 0 1 199.291759 40.238472 510.222587 510.222587 0 0 1 162.745886 109.722952 510.284648 510.284648 0 0 1 109.730709 162.745886A508.841741 508.841741 0 0 1 1023.999069 512a508.826226 508.826226 0 0 1-40.238472 199.291759 510.292406 510.292406 0 0 1-109.73071 162.745886 510.27689 510.27689 0 0 1-162.745886 109.730709A508.795196 508.795196 0 0 1 512 1023.999069zM252.695744 543.348307a13.4904 13.4904 0 0 0 3.878781 9.471982 13.335248 13.335248 0 0 0 9.471983 3.917569l127.456738-0.201697a13.428339 13.428339 0 0 0 13.412824-13.412824l0.06206-51.680875a87.272569 87.272569 0 0 1 24.420804-20.030025 161.489161 161.489161 0 0 1 82.493911-20.16966h0.279272a159.573043 159.573043 0 0 1 82.230154 20.084327 86.985539 86.985539 0 0 1 24.296683 20.084327v51.362816a13.358521 13.358521 0 0 0 3.878781 9.471983 13.226643 13.226643 0 0 0 9.425437 3.917568l114.400762-0.170666h13.110279a13.358521 13.358521 0 0 0 9.495255-3.917569 13.451612 13.451612 0 0 0 3.878781-9.495255l0.054303-29.168432a13.226643 13.226643 0 0 0-0.387878-3.157327l-0.558544-2.327269a88.436203 88.436203 0 0 0-6.826655-27.570374c-25.553408-59.453953-131.288973-104.292659-245.914704-104.292659h-0.589575a511.355191 511.355191 0 0 0-134.903997 18.967238c-45.102463 12.776704-80.802762 30.681156-100.514726 50.424151a114.990336 114.990336 0 0 0-24.901773 35.645996 86.357176 86.357176 0 0 0-7.57138 34.505634l-0.054303 27.787586z" fill="#FC4A46" p-id="5997"></path></svg> : null
                  }
                </div>
                <div className="tccc-call-logout">
                  <svg onClick={logoutTcccFn} t="1729839941503" className="tcc-logout-icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="8829" width="200" height="200"><path d="M515.7 919.3c-55.9 0-110-10.9-161.1-32.5-49.3-20.8-93.5-50.7-131.5-88.7s-67.8-82.2-88.7-131.5c-21.6-51-32.5-105.2-32.5-161.1 0-86.6 26.5-169.5 76.5-239.8 24.1-33.8 53.1-63.8 86.1-89 33.4-25.5 70.2-45.7 109.5-60 13-4.7 27.3 2 32 14.9s-2 27.3-14.9 32C248 215.7 151.8 353.1 151.8 505.5c0 200.6 163.2 363.8 363.8 363.8 200.6 0 363.8-163.2 363.8-363.8 0-156.7-99.8-295.4-248.2-345.1-13.1-4.4-20.2-18.6-15.8-31.6 4.4-13.1 18.5-20.2 31.6-15.8 40.6 13.6 78.7 33.4 113.4 58.8 34.2 25.1 64.3 55.3 89.3 89.5 52.1 71.2 79.7 155.6 79.7 244.1 0 55.9-10.9 110-32.5 161.1-20.8 49.3-50.7 93.5-88.7 131.5s-82.2 67.8-131.5 88.7c-51 21.6-105.2 32.6-161 32.6z" fill="#1CD38D" p-id="8830"></path><path d="M510.9 530.5c-16.6 0-30-13.4-30-30V116.7c0-16.6 13.4-30 30-30s30 13.4 30 30v383.8c0 16.5-13.5 30-30 30z" fill="#1CD38D" p-id="8831"></path></svg>
                </div>
              </>
            }
          </> : null
        }
    </div>
  );
};

export default TcccControlUi;
